import React from "react";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import DefaultImage from "../../../assets/default-product-image.webp";
import { IncrementButton } from "../../increment_button";
import { update_quantity } from "../../../api/calls/basket/update_quantity";
import { calculate_basket_thunk } from "../../../reducers/slices/basket/thunks/calculate_basket_thunk";
import { setMainModal } from "../../../reducers/slices/main";
import { formatPrice } from "../../../helpers/formatPrice";
export function BasketItem(props) {
    const dispatch = useDispatch();
    const { item, onRemove } = props;
    const { quantity } = item;
    const { basket } = useSelector((state) => state.basketState);
    const { _id: basketId } = basket || {};
    const onQuantityChange = (value) => {
        update_quantity({
            _id: basketId,
            product: {
                _id: item?._id,
                quantity: value.toString(),
            },
        }).then((response) => {
            if (response.success) {
                dispatch(calculate_basket_thunk(response));
            }
            else {
                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    };
    return (React.createElement("div", { className: "w-full border-b border-neutral-gray flex gap-4 pb-1 pt-2" },
        React.createElement("img", { className: `w-[4.69rem] h-[6rem] ${item?.image_url ? "object-contain opacity-100" : "object-contain opacity-20"}`, alt: item?.sku, src: item?.image_url ?? DefaultImage, onError: (e) => {
                e.currentTarget.src = DefaultImage;
            } }),
        React.createElement("div", { className: "w-full flex flex-row gap-2" },
            React.createElement("div", { className: "w-10/12" },
                React.createElement("div", { className: "w-full text-md pb-2" },
                    React.createElement("div", { className: "font-normal text-xs" }, item?.sku),
                    React.createElement("div", { className: "font-semibold text-sm line-clamp-3 leading-tight" }, item?.title),
                    React.createElement("div", { className: "flex justify-between gap-2 py-2" },
                        React.createElement(IncrementButton, { value: parseInt(quantity), enableDebounce: true, onChange: (value) => onQuantityChange(value) }),
                        React.createElement("div", { className: "flex flex-col justify-end flex-nowrap text-nowrap" },
                            React.createElement("div", { className: "text-sm font-semibold my-auto text-end" }, `${formatPrice({
                                value: item?.price?.toString() ?? "0",
                                decimalPlaces: 2,
                            })}`))))),
            React.createElement("div", { className: "flex justify-end items-start w-2/12 py-2" },
                React.createElement("button", { className: `flex justify-center items-center w-7 h-7 rounded-full bg-black ease-in-out duration-200 hover:opacity-60`, onClick: () => onRemove(item._id) },
                    React.createElement(Icon, { className: "text-white m-auto", icon: "lucide:x", width: "16", height: "16" }))))));
}
